import getCropName from './cropNameLookup';

import waterUseLookupArqpcty from './water_use_lookup_arqpcty.json';
import waterUseLookupColca from './water_use_lookup_colca.json';
import waterUseLookupMajes from './water_use_lookup_majes.json';

const waterUseLookup = {
  ...waterUseLookupArqpcty,
  ...waterUseLookupColca,
  ...waterUseLookupMajes,
};

const plantingTimeTranslations = {
  es: {
    'Perennial': 'perenne',
    'Jan': 'ene',
    'Feb': 'feb',
    'Mar': 'mar',
    'Apr': 'abr',
    'May': 'mayo',
    'Jun': 'jun',
    'Jul': 'jul',
    'Aug': 'ago',
    'Sept': 'sep',
    'Oct': 'oct',
    'Nov': 'nov',
    'Dec': 'dic',
    'Oct-Nov': 'oct-nov',
    'Sept-Dec': 'sep-dic',
    'Aug-Sept': 'ago-sep',
    'Sept-Oct': 'sep-oct',
    'Dec-Jan': 'dic-ene',
    'Feb-Mar': 'feb-mar',
    'Mar-Apr': 'mar-abr',
    'Feb-Apr': 'feb-abr',
    'May-Aug': 'mayo-ago',
    'Feb-Jun': 'feb-jun'
  }
}

function getPlantingTimeTranslation(lang, plantingTime) {
  if (lang === 'en') {
    return plantingTime;
  } else if (lang === 'es') {
    return plantingTimeTranslations[lang][plantingTime];
  } else {
    return 'TRANSLATE';
  }
}


export default function lookupWaterUse(values, lang) {
  const { crops, soilCode } = values;
  let weatherStation = values.weatherStation.toLowerCase();
  let waterUseData = [];

  crops.forEach((crop) => {
    let cropName = getCropName(lang, crop.name);
    const lookupRecords = waterUseLookup[weatherStation][soilCode][crop.name];
    const plantingTime = getPlantingTimeTranslation(lang, lookupRecords['Typical planting time']);

    waterUseData.push({
      name: cropName,
      ha: {
        monthlyWaterNeeds:
          lookupRecords['monthly water needs (m^3/month/ha)'].toFixed(0),
        growingWaterNeeds:
          lookupRecords['growing season water needs (m^3/ha)'].toFixed(0),
      },
      topos: {
        monthlyWaterNeeds:
          lookupRecords['monthly water needs (m^3/month/topos)'].toFixed(0),
        growingWaterNeeds:
          lookupRecords['growing season water needs (m^3/topos)'].toFixed(0),
      },
      monthsGrown: lookupRecords['Months grown'],
      typicalPlantingTime: plantingTime,
    });
  });

  return waterUseData;
}
